import request from '@/utils/request'
// banner列表
export function bannerListData(data) {
  return request({
    url: '/sys/banner/list',
    method: 'post',
    data
  })
}
// banner删除
export function bannerDelete(data) {
  return request({
    url: '/sys/banner/delete',
    method: 'post',
    data
  })
}
// banner添加
export function bannerSaveData(data) {
  return request({
    url: '/sys/banner/save',
    method: 'post',
    data
  })
}